import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=3080e6f9"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=3080e6f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports